/* eslint-disable no-self-assign */
import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./MyUser.css";
import { useRol } from "../../Context";
import profile from '../../icons/person-circle-outline.svg';
import password from '../../icons/key-sharp.svg';
import factura from '../../icons/cash-sharp.svg';
import soporte from '../../icons/soporte.svg';
import logo from '../../icons/logo-toolbar.png';

const ROLES_VER_COMO = ['Administrador', 'Supervisor', 'Coordinador', 'Asesor'];
const ROL_DISPLAY_MAP = { 'Administrador': 'Coordinador', 'Supervisor': 'Supervisor', 'Coordinador': 'Coordinador', 'Asesor': 'Asesor' };

function MyUser({ isRightMenuOpen }) {
    const context = useRol();
    const { dataProfile, setDataProfile, setLoading, rol, setRol, rolOriginal, rolActivo, setRolActivo, staff, userEmail } = context || {};
    const logout = context?.logout || (() => {
        // Logout function not available
        window.location.href = '/sign-in';
    });

    let nombre = dataProfile ? dataProfile.first_name : "User";

    const handleReload = () => {
        logout();
    };

    if (nombre === "User") {
        handleReload()
    }

    useEffect(() => {
        if (nombre === null) {
            setLoading(true);
            setDataProfile();
        }
        const textElements = document.querySelectorAll('.texto');
        textElements.forEach((element) => {
            const text = element.textContent;
            const firstLetter = document.createElement('span');
            firstLetter.className = 'primera-letra';
            firstLetter.textContent = text[0];
            element.textContent = ''; // Elimina el texto original
            element.appendChild(firstLetter);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nombre]);

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [verComoLabel, setVerComoLabel] = useState(rolOriginal || rol);
    const menuRef = useRef(null);

    const handleVerComo = (label) => {
        setVerComoLabel(label);
        setRol(ROL_DISPLAY_MAP[label] || label);
        setRolActivo(label);
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <>
            {/* my user web */}
            <div className="saludo" onClick={toggleMenu} ref={menuRef}>
                <label>Hola, <b>{nombre}</b></label>
                <div className="texto">
                    {nombre}
                </div>
                {isMenuOpen && (
                    <div className="menu" >
                        <ul>
                            <NavLink to={'/Perfil'} className="nav-links">
                                <li>
                                    <img src={profile} alt="person" />
                                    Mi perfil
                                </li>
                            </NavLink>
                            <NavLink to={'/Contrasena'} className="nav-links">
                                <li>
                                    <img src={password} alt="key" />
                                    Cambiar contraseña
                                </li>
                            </NavLink>
                            <NavLink to={'/Facturacion'} className="nav-links">
                                <li>
                                    <img src={factura} alt="cash" />
                                    Faturación
                                </li>
                            </NavLink>
                            <NavLink to={'/Soporte'} className="nav-links">
                                <li>
                                    <img src={soporte} alt="suport" />
                                    Soporte
                                </li>
                            </NavLink>
                            {staff && (
                                <li className="ver-como-section" onClick={e => e.stopPropagation()}>
                                    <span className="ver-como-header">Ver como</span>
                                    <select
                                        className="ver-como-select"
                                        value={verComoLabel}
                                        onChange={e => handleVerComo(e.target.value)}
                                    >
                                        {ROLES_VER_COMO.map(r => (
                                            <option key={r} value={r}>{r}</option>
                                        ))}
                                    </select>
                                </li>
                            )}
                            <div className="button">
                                <button onClick={handleReload}>Cerrar sesión</button>
                            </div>
                        </ul>
                    </div>
                )}
            </div>
            {/* my user movil */}
            {isRightMenuOpen && (
                <div className="menu-overlay">
                </div>
            )}
            <div className={`side-menu-movil-right ${isRightMenuOpen ? 'open' : 'right'}`}>
                <div className="barra-logo-movil">
                    <img src={logo} alt="logo" />
                    <label>Prospectia</label>
                </div>
                <div className="side-options-movil">
                    <ul className="marca-movil">
                        <li><b>Hola, {nombre}</b></li>
                        <li>{rol}</li>
                        <li className="dos">{userEmail}</li>
                    </ul>
                    <ul className="links-movil">
                        <NavLink to={'/Perfil'} className="nav-links-movil">
                            <li>
                                <img src={profile} alt="profile" />
                                <label>Mi perfil</label>
                            </li>
                        </NavLink>
                        <NavLink to={'/Contrasena'} className="nav-links-movil">
                            <li>
                                <img src={password} alt="password" />
                                <label>Cambiar contraseña</label>
                            </li>
                        </NavLink>
                        <NavLink to={'/Facturacion'} className="nav-links-movil">
                            <li>
                                <img src={factura} alt="factura" />
                                <label>Facturacion</label>
                            </li>
                        </NavLink>
                    </ul>
                    {staff && (
                        <div className="ver-como-movil">
                            <span className="ver-como-movil-header">Ver como</span>
                            <select
                                className="ver-como-select"
                                value={verComoLabel}
                                onChange={e => handleVerComo(e.target.value)}
                            >
                                {ROLES_VER_COMO.map(r => (
                                    <option key={r} value={r}>{r}</option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export { MyUser }